import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DataService } from 'src/app/services/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { ViewChild, ElementRef, Inject, PLATFORM_ID } from '@angular/core';


export interface OrganizerVerificationPayload {
  type: string;

  organizer_id: number;
  user_id: number;

  company_name: string;
  email: string;

  kyc_status: 'pending' | 'approved' | 'rejected';
  step: number;
  is_active: number;

  organizer_description: string;
  organizer_logo: string | null;
  organizer_website: string;

  organizer_contact_email: string;
  organizer_contact_phone: string;

  organizer_address: string;
  organizer_city: string;
  organizer_state: string;
  organizer_country: string;
  organizer_postal_code: string;

  organizer_kyc_documents: any | null;

  organizer_tickets_sold: number;
  organizer_organizer_type: string;
  organizer_organizer_for: string;
  organizer_organizer_content: string;

  organizer_legal_documents: number;
  organizer_bank_documents: number;
  organizer_verify_legal_documents: number;
  organizer_verify_bank_documents: number;

  organizer_reject_reason: string | null;

  organizer_created_at: string; // YYYY-MM-DD HH:mm:ss
  organizer_updated_at: string; // YYYY-MM-DD HH:mm:ss

  user_first_name: string;
  user_last_name: string;
  user_full_name: string;

  exp: number;
  iat: number;
}


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  // @ViewChild('fileInput') fileInput!: ElementRef;
  homeForm!: FormGroup;
  isVatRegistered = false;
  isUaeResident = true;
  decoded!: OrganizerVerificationPayload;
  token: any;
  fileToUpload: File | null = null;

  constructor(private _ds: DataService,
    private fb: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    // this.initForm();

    this.homeForm = this.fb.group({

      organiserProfile: ['ndividual'],
      displayName: ['', Validators.required ],
      aboutOrganiser: ['', Validators.required ],
      uploadFile: ['', Validators.required ],
      fName: ['',Validators.required ],
      lName: ['', Validators.required ],
      wEmail: ['', Validators.required ],
      mNumber: ['', Validators.required ],
      cCode: ['', Validators.required ],
      bankAccount: ['', Validators.required ],
      emirate: ['', Validators.required ],
      bankIFSC: ['', Validators.required ],
      registeredLegalName: ['', Validators.required ],
      tradeLicenseNumber: ['', Validators.required ],
      accountType: ['', Validators.required ],
      registeredAddressUAE: ['', Validators.required ],
      isVatRegistered: [false],
      vatNumber: ['', Validators.required ],
      tradeLicenseCopyUpload: ['', Validators.required ],
      authorisedSignatoryIDUpload: ['', Validators.required ],
      signatoryName: ['', Validators.required ],
      signatoryDesignation: ['', Validators.required ],
      signatoryEmail: ['', Validators.required ],
      signatoryMobile: ['', Validators.required ],
      fullLegalName: ['', Validators.required ],
      legalNameNationality: ['', Validators.required ], 
      residentInUAE: ['', Validators.required ], 
      passportNumber: ['', Validators.required ],
      passportFileUpload: ['', Validators.required ],
      emiratesIDNumber: ['', Validators.required ],
      emiratesFileUpload: ['', Validators.required ],
      address: ['', Validators.required ],
      country: ['', Validators.required ],
      city: ['', Validators.required ],
      willAnyEventsServeAlcohol: ['No'],
      willYouHostEvents: ['No'],

    })

    
    this.route.queryParamMap.subscribe(params => {

      this.token = params.get('token');
      const tokenized = this.token
      this.decoded = jwtDecode<OrganizerVerificationPayload>(tokenized);
      console.log(this.decoded);

    });

  }

  currentStep = 1;

  goStep(step: number) {
    this.currentStep = step;
  }

  // initForm() {
  //   this.homeForm = this.fb.group({
  //     organizerType: ['Individual'],
  //     registeredLegalName: ['', Validators.required],
  //     tradeLicenseNumber: ['', Validators.required],
  //     issuingAuthority: ['', Validators.required],
  //     signatoryName: ['', Validators.required],
  //     signatoryEmail: ['', [Validators.required, Validators.email]],
  //     signatoryMobile: ['', Validators.required],
  //     registeredAddress: ['', Validators.required],
  //     isVatRegistered: [false],
  //     vatRegistrationNumber: [''],
  //     organizerId: [5],
  //     tradeLicenseCopy: [''],
  //     authorisedSignatoryId: [''],
  //     signatoryDesignation: ['', Validators.required],
  //     fullLegalName: ['', Validators.required],
  //     nationality: ['', Validators.required],
  //     isUaeResident: [false],
  //     emiratesIdNumber: [''],
  //     emiratesIdCopy: [''],
  //     passportNumber: [''],
  //     passportCopy: [''],
  //     address: ['', Validators.required],
  //     addressCountry: ['', Validators.required],
  //     addressCity: ['', Validators.required],
  //     willSellAlcohol: [false],
  //     willHostUnder18: [false],
  //   });
  // }

handleBrochureInput(event: Event) {
  const input = event.target as HTMLInputElement;

  if (!input.files || input.files.length === 0) {
    return;
  }

  const file: File = input.files[0];

  const reader = new FileReader();

  reader.onload = () => {
    const base64 = reader.result as string;
    console.log('Base64:', base64);

    // 👉 yahin se API ko bhejo ya form me set karo
    // this.homeForm.patchValue({ brochure: base64 });
  };

  reader.onerror = (error) => {
    console.error('File read error:', error);
  };

  reader.readAsDataURL(file); // ⭐ Base64 banata hai
}

handleBrochureInput2(event: Event) {
  const input = event.target as HTMLInputElement;

  if (!input.files || input.files.length === 0) {
    return;
  }

  const file: File = input.files[0];

  const reader = new FileReader();

  reader.onload = () => {
    const base642 = reader.result as string;
    console.log('Base64:', base642);

    // 👉 yahin se API ko bhejo ya form me set karo
    // this.homeForm.patchValue({ brochure: base64 });
  };

  reader.onerror = (error) => {
    console.error('File read error:', error);
  };

  reader.readAsDataURL(file); // ⭐ Base64 banata hai
}

handleBrochureInput3(event: Event) {
  const input = event.target as HTMLInputElement;

  if (!input.files || input.files.length === 0) {
    return;
  }

  const file: File = input.files[0];

  const reader = new FileReader();

  reader.onload = () => {
    const base643 = reader.result as string;
    console.log('Base64:', base643);

    // 👉 yahin se API ko bhejo ya form me set karo
    // this.homeForm.patchValue({ brochure: base64 });
  };

  reader.onerror = (error) => {
    console.error('File read error:', error);
  };

  reader.readAsDataURL(file); // ⭐ Base64 banata hai
}

handleBrochureInput4(event: Event) {
  const input = event.target as HTMLInputElement;

  if (!input.files || input.files.length === 0) {
    return;
  }

  const file: File = input.files[0];

  const reader = new FileReader();

  reader.onload = () => {
    const base644 = reader.result as string;
    console.log('Base64:', base644);

    // 👉 yahin se API ko bhejo ya form me set karo
    // this.homeForm.patchValue({ brochure: base64 });
  };

  reader.onerror = (error) => {
    console.error('File read error:', error);
  };

  reader.readAsDataURL(file); // ⭐ Base64 banata hai
}

handleBrochureInput5(event: Event) {
  const input = event.target as HTMLInputElement;

  if (!input.files || input.files.length === 0) {
    return;
  }

  const file: File = input.files[0];

  const reader = new FileReader();

  reader.onload = () => {
    const base645 = reader.result as string;
    console.log('Base64:', base645);

    // 👉 yahin se API ko bhejo ya form me set karo
    // this.homeForm.patchValue({ brochure: base64 });
  };

  reader.onerror = (error) => {
    console.error('File read error:', error);
  };

  reader.readAsDataURL(file); // ⭐ Base64 banata hai
}



  submitForm() {
    if (this.homeForm.invalid) {

      const payload = {
        ...this.homeForm.value
      };

      console.log('Sending JSON:', payload);

      this._ds.uploadDoc(payload).subscribe({
        next: (res: any) => {
          console.log('Success:', res);
        },
        error: (err: any) => {
          console.error('Error:', err);
        }
      });

    } else {
      this.homeForm.markAllAsTouched();
    }
  }

}